
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

// Redux


// Service
import { TranslationService } from '../common/services/languages/translation.service';
import { HeaderInterceptorService } from './services/header-interceptor/header-interceptor.service';
// Module
import { LanguageModule } from '../common/services/languages/language.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Components
import { ShowResultComponent } from '../svpp/show-result/show-result.component';
import { ConfirmationBarComponent } from './confirmation-bar/confirmation-bar.component';
import { GenerationComponent } from '../svpp/generation/generation.component';
import { UserRolesComponent } from '../svpp/user-roles/user-roles.component';
import { DashboardContentComponent } from '../svpp/dashboard-content/dashboard-content.component';
import { SvppMainComponent } from '../svpp/svpp-main/svpp-main.component';
import { UploadDialogComponent } from '../svpp/upload-dialog/upload-dialog.component';
import { RouterModule } from '@angular/router';
import { ProductMappingComponent } from './product-mapping/product-mapping.component';
import { AsiProductMapComponent } from './asi-product-map/asi-product-map.component';
import { ProductOptionsComponent } from './product-options/product-options.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SvppRoutingModule } from './svpp-routing.module';
import { CommonModule } from '@angular/common';
@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [FormsModule,
    ReactiveFormsModule,
    LanguageModule,
    RouterModule,
    NgxMatSelectSearchModule,
    SvppRoutingModule,
    CommonModule, ShowResultComponent,
    ConfirmationBarComponent,
    GenerationComponent,
    ProductOptionsComponent,
    UserRolesComponent,
    DashboardContentComponent,
    SvppMainComponent,
    ProductMappingComponent,
    AsiProductMapComponent], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptorService, multi: true },
        TranslationService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class SVPPModule { }
